// extracted by mini-css-extract-plugin
export default {"menuIcon":"VendorMenuBar_menuIcon__bm+jT","backIcon":"VendorMenuBar_backIcon__ZXosB","fixed":"VendorMenuBar_fixed__8M6LV"};